import { useState, useEffect, useContext, useCallback  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';
import dayjs from 'dayjs';
import { CcLoader } from '../commonComponents/generalComponents';



export default function SnippetTimerReport() {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [timerStats, setTimerStats] = useState(undefined)
    const [imageUrl, setImageUrl] = useState(undefined)

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setTimerStats(undefined)
        setImageUrl(undefined)
        setSnippetInfo(undefined)
        getSnippetTimerStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetTimerStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/timer/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;
      if (data.templateMetadata) getTemplatePreview(data.templateMetadata)

      setTimerStats(data)

    } catch (error) {
      console.log(error);
    }
  }
    const getTemplatePreview = async (templateModel, urlParams, filters) => {
        try {
        const url = `${process.env.REACT_APP_LION_API_URL}/Templates/preview`;

        //const requestObj = prepareModelToPost(templateModel, urlParams, filters)
        const response = await axios.post(url, templateModel);
        setImageUrl(`data:image/gif;base64,${response.data.imageBase64}`)


        } catch (error) {
        }
    }

  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}?allInfo=true`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetInfo(data)

  

    } catch (error) {
      console.log(error);
    }
  }
  const getTimerTypePretty = () => {
    if (timerStats == null) return undefined

    switch (timerStats.timerType) {
        case "countdown":
            return "Count Down"
        case "countup":
            return "Count Up"
        case "customDateDown":
            return "Personalised Count Down"
        case "customDateUp":
            return "Personalised Count Up"
        default:
            return undefined
    }
  }
  const getDateTitle = () => {
    if (timerStats == null) return undefined

    switch (timerStats.timerType) {
        case "countdown":
            return "Expiry Date"
        case "countup":
            return "Start date"
        case "customDateDown":
            return "Expiry Date"
        case "customDateUp":
            return "Start date"
        default:
            return undefined
    }
  }
  const getTimezonePretty = () => {
    if (timerStats == null) return undefined

    switch (timerStats.timerType) {
        case "countdown":
            return timerStats.timerDateTimeZone
        case "countup":
            return timerStats.timerDateTimeZone
        case "customDateDown":
            return timerStats.inputDateFormat.includes("z") ? 'Custom time offset' : timerStats.timerDateTimeZone
        case "customDateUp":
            return timerStats.inputDateFormat.includes("z") ? 'Custom time offset' : timerStats.timerDateTimeZone
        default:
            return undefined
    }
  }

    return <div>
            <CcTitle>Element Report Timer</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Total Views', value: timerStats ? timerStats.totalOpens : undefined },
                                    {title: 'Total Clicks', value: timerStats ? timerStats.totalClicks : undefined},
                                    {title: 'Timer Type', value: getTimerTypePretty()},
                                    {title: getDateTitle(), value: timerStats ? dayjs(timerStats.timerDate).format('DD MMM YYYY HH:mm') : undefined, footer: getTimezonePretty()},
                                    ]} />
            </div>
            <div className='mt-6 bg-slate-200 rounded p-4 w-fit'>
                {imageUrl == null &&
                  <div className='w-[800px] flex flex-col gap-y-2 justify-center items-center'>
                    <CcLoader size={64} />
                    <div className='font-poppins text-ccColorDarkTeal'>Loading timer preview...</div>
                  </div>
                }
                {imageUrl &&
                  <div className='w-[800px] overflow-auto'>
                    <img src={imageUrl} />
                  </div>
                }
            </div>
    </div>
}